import { createToast } from "@/modules/toast-message"
import { castFromStrings } from "@app/helpers/cast";
import { createSingularAsyncApi } from "../../partials/async";
import { dataSet } from "../../../helpers/dot";

export default function createGetProgressionApi(details) {
    /**
     * Gets the progress from an existing key
     */
    const get = createSingularAsyncApi(
        'bt_memberships_get_progress',
        'GET',
        {
            onDataRetrieved: async (data) => {
                if(data.success === false){
                    return data
                }

                details.value.email = data.email
    
                return castFromStrings(
                    await mapFromSubmission(data)
                )
            }
        }
    );

    /**
     * When we fail to get the progress we should handle it accordingly
     */
    get.api.callbacks.add(
        'onError',
        (data) => {
            if(data.code === 404){
                //Remove the key from the url
                window.history.replaceState(null, null, window.location.pathname)

                createToast("Your saved data could not be found. We only retain saved data for 30 days after this time it is deleted from our system.", "error")
            } else {
                createToast("Your saved failed to load", "error")
            }

            details.value.key = null
        } 
    )

    return get
}

/**
 * Maps a submission back into the formatted answers
 * 
 * @param {Object} data 
 * @returns {Object}
 */
async function mapFromSubmission(data){
    let { data: answers, ...core } = data

    for(const answer of answers){
        dataSet(core, `data.${answer.field_name}`, await maybeMapFile(answer.answer))
    }

    return core
}

/**
 * Maps files uploaded back into file objects
 * 
 * @param {any} answer 
 * @returns {any}
 */
async function maybeMapFile(answer){
    if(
        typeof answer?.file === 'string' 
        && ['extension', 'filename', 'mime_type'].every(
            (key) => (answer?.meta ?? {}).hasOwnProperty(key)
        )
    ){
        //Get the file from the temporary URL
        const response = await fetch(answer.file);

        /**
         * As we don't make use of the inputs directly we don't need fileInput.files to give the correct value
         * so just setting the file into the state works fine
         * 
         * If we did need to do this we could make use of the DataTransfer object which is the only way to instantiate a FileList
         * 
         * Example:
         *     const dataTransfer = new DataTransfer();
         *
         *     files.forEach((file) => {
         *         dataTransfer.items.add(file);
         *     });
         *
         *     fileInput.files = dataTransfer.files;
         */

        /**
         * Instantiate the file object to make it as close as possible to the one we uploaded when saving progression
         * We can use the meta to correct most data but all we really need to save the membership is the file itself
         * as we could compute its mime type but as S3 can sometimes play up with non-specified mime-types we should
         * just take the one the user uploaded and Laravel computed in the first place
         */
        return new File([await response.blob()], answer.meta.filename, { type: answer.meta.mime_type });
    }

    return answer
}